/* This is generated code, don't alter */
var IfcPipeSegmentTypeEnum;
(function (IfcPipeSegmentTypeEnum) {
    IfcPipeSegmentTypeEnum[IfcPipeSegmentTypeEnum["CULVERT"] = 0] = "CULVERT";
    IfcPipeSegmentTypeEnum[IfcPipeSegmentTypeEnum["FLEXIBLESEGMENT"] = 1] = "FLEXIBLESEGMENT";
    IfcPipeSegmentTypeEnum[IfcPipeSegmentTypeEnum["RIGIDSEGMENT"] = 2] = "RIGIDSEGMENT";
    IfcPipeSegmentTypeEnum[IfcPipeSegmentTypeEnum["GUTTER"] = 3] = "GUTTER";
    IfcPipeSegmentTypeEnum[IfcPipeSegmentTypeEnum["SPOOL"] = 4] = "SPOOL";
    IfcPipeSegmentTypeEnum[IfcPipeSegmentTypeEnum["USERDEFINED"] = 5] = "USERDEFINED";
    IfcPipeSegmentTypeEnum[IfcPipeSegmentTypeEnum["NOTDEFINED"] = 6] = "NOTDEFINED";
})(IfcPipeSegmentTypeEnum || (IfcPipeSegmentTypeEnum = {}));
const IfcPipeSegmentTypeEnumCount = 7;
export { IfcPipeSegmentTypeEnum, IfcPipeSegmentTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcPipeSegmentTypeEnum = new Int32Array([293]);
let prefixSumAddressIfcPipeSegmentTypeEnum = new Uint32Array([0, 17, 26, 33, 41, 53, 67, 80]);
let slotMapIfcPipeSegmentTypeEnum = new Int32Array([1, 0, 4, 3, 6, 2, 5]);
let encodedDataIfcPipeSegmentTypeEnum = (new TextEncoder()).encode(".FLEXIBLESEGMENT..CULVERT..SPOOL..GUTTER..NOTDEFINED..RIGIDSEGMENT..USERDEFINED.");
let IfcPipeSegmentTypeEnumSearch = new MinimalPerfectHash(gMapIfcPipeSegmentTypeEnum, prefixSumAddressIfcPipeSegmentTypeEnum, slotMapIfcPipeSegmentTypeEnum, encodedDataIfcPipeSegmentTypeEnum);
export { IfcPipeSegmentTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcPipeSegmentTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcPipeSegmentTypeEnumSearch, input, cursor, endCursor);
}
